import { useEffect, useState } from 'react';
import en from '../../../../lang/en-us';
import { RowInfoType } from './change-email-list';
import SuccessScreen from '../SuccessScreen';
import { NoteModals } from '../../../../lib/NoteModals';
import { connect } from 'react-redux';
import { onLogout } from '../../../../redux-store/actions/login';
import { RootStateType } from '../../../../redux-store/reducers';
const { dashboard } = en;

export const getList = (data: RowInfoType[]) => {
    return data.reduce((prev: any, curr: RowInfoType) => {
        curr.schemeNames?.forEach((scheme: string, index) => {
            prev = [
                ...prev,
                {
                    text: `${prev.length + 1}. ${curr.amcName} - ${scheme}`,
                },
            ];
        });
        return prev;
    }, []);
};

function ChangeEmailSuccess(props: any) {
    const { email, reqId, data = [], isOffline = false } = props.location.state || {};
    const [showModal, setModal] = useState(false);

    useEffect(() => {
        !isOffline && !!props.email ? setModal(true) : setModal(false);
    }, []);

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    const _handleModalClose = () => {
        if (!isOffline) {
            try {
                const { pan, pekrn } = props;
                const payload = {
                    pan: pan,
                    pekrn: pekrn,
                };
                props.onLogout(payload);
            } catch (e: any) {
                console.log(e);
            }
        }
    };

    return (
        <div className="curved-bg">
            <SuccessScreen
                heading={dashboard.changeEmail.Success.back}
                backLink="nct"
                info1={dashboard.changeEmail.Success.subHeadingInfo1}
                infospan1={email}
                info2={dashboard.changeEmail.Success.subHeadingInfo2}
                infospan2={reqId}
                info3={dashboard.changeEmail.Success.subHeadingInfo3}
                // list={getList(data)}
                handleClick={() => props.history.push('/portal/track')}
                backNavigation={() => props.history.goBack()}
            />
            <NoteModals
                showModal={showModal}
                heading={dashboard.Success.success}
                info={`${dashboard.Success.sucessEmailMsg1} ${reqId}.${dashboard.Success.successMsg2}`}
                proceedBtn={'Okay'}
                onProceed={_handleModalClose}
            />
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), { onLogout })(
    ChangeEmailSuccess,
);
